export default __webpack_public_path__ + "static/media/opening-4.961af610.jpg";